export default function MuteButton({ muted, setMuted, style }) {
  return (
    <button
      className="panel mute-btn"
      onClick={() => setMuted((m) => !m)}
      style={{
        background: "none",
        border: "none",
        cursor: "pointer",
        outline: "none",
        padding: 0,
        marginRight: 16,
        ...style,
      }}
    >
      {muted ? (
        // Muted icon (speaker with red dash)
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <g>
            <path d="M6 12v8h6l7 6V6l-7 6H6z" fill="#888" />
            <line
              x1="8"
              y1="8"
              x2="24"
              y2="24"
              stroke="#e74c3c"
              strokeWidth="3"
            />
          </g>
        </svg>
      ) : (
        // Speaker icon
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M6 12v8h6l7 6V6l-7 6H6z" fill="#888" />
          <path
            d="M23 11a6 6 0 010 10"
            stroke="#888"
            strokeWidth="2"
            fill="none"
          />
        </svg>
      )}
    </button>
  );
}
